const initialState = {
  'byId': new Map(),
};

export function employeesReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_EMPLOYEES':
      return {
      ...state,
      byId: new Map([...state.byId, ...action.payload]),
    };
    default:
      return state;
  }
}
